<ng-container>
  <div *ngIf="!mobileMode" id="instructor-toggle-container" class="instructor-toggle-container">
    <button
      mat-icon-button
      [matMenuTriggerFor]="instructorMenu"
      class="instructor-toggle-button"
      matTooltip="Filter Instructors"
      [color]="selectedInstructors.length < instructors.length ? 'accent' : 'primary'"
    >
      <mat-icon>{{selectedInstructors.length < instructors.length ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>

    <mat-menu #instructorMenu="matMenu" class="instructor-menu">
      <div class="menu-header" (click)="$event.stopPropagation()">
        <span class="menu-title">Visible Instructors</span>
      </div>

      <mat-divider></mat-divider>

      <div class="instructor-list">
        <button
          mat-menu-item
          *ngFor="let instructor of instructors"
          (click)="toggleInstructor(instructor.id)"
          class="instructor-item"
        >
          <mat-checkbox
            [checked]="isSelected(instructor.id)"
            (click)="$event.stopPropagation()"
            (change)="toggleInstructor(instructor.id, $event)"
            class="instructor-checkbox"
          >
            {{ instructor.title }}
          </mat-checkbox>
        </button>
      </div>
    </mat-menu>
  </div>

  <div *ngIf="mobileMode" class="instructor-toggle-mobile">
    <mat-select [value]="selectedInstructorId" (selectionChange)="toggleInstructor($event.value)">
      <mat-option *ngFor="let instructor of instructors" [value]="instructor.id">
        {{ instructor.title }}
      </mat-option>
    </mat-select>
  </div>
</ng-container>
